import { createSlice } from "@reduxjs/toolkit";
import { rpmPatientAction } from "../actions/rpmPatientsAction";

const initialState = {
  rpmReport: null,
  rpmReportUrl: null,
  rpmReportFile: null,
  selectedRpmPatient: null,
  isTransferredFromRpm: false,
  rpmPatientBilling: null,
};

const rpmPatient = createSlice({
  name: "rpmPatient",
  initialState,
  reducers: rpmPatientAction,
});

export const {
  setRpmReport,
  setRpmReportUrl,
  setRpmReportFile,
  setRpmPatientBilling,
  setSelectedRpmPatient,
  resetRpmPatientValues,
  setIsTransferredFromRpm,
} = rpmPatient.actions;

export default rpmPatient.reducer;
